import apiClient from './apiClient';

interface DashboardStats {
  activeEmergencies: number;
  totalUsers: number;
  healthRecords: number;
  avgResponseTime: number;
  emergencyTrend?: number;
  userGrowth?: number;
  responseTimeTrend?: number;
  emergencyTypes?: {
    heart_attack: number;
    stroke: number;
    fall: number;
    general: number;
  };
}

interface EmergencyTrend {
  date: string;
  total: number;
  resolved: number;
  active: number;
}

interface UserActivity {
  hour: string;
  active: number;
}

class DashboardService {
  async getStats(): Promise<DashboardStats> {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
  }

  async getEmergencyTrend(days: number = 7): Promise<EmergencyTrend[]> {
    const response = await apiClient.get('/dashboard/emergency-trend', {
      params: { days },
    });
    return response.data;
  }

  async getUserActivity(hours: number = 24): Promise<UserActivity[]> {
    const response = await apiClient.get('/dashboard/user-activity', {
      params: { hours },
    });
    return response.data;
  }

  async getRecentEmergencies(limit: number = 10): Promise<any[]> {
    const response = await apiClient.get('/emergency/alerts', {
      params: { limit, orderBy: 'created_at', order: 'desc' },
    });
    return response.data;
  }

  async getActiveEmergenciesMap(): Promise<any[]> {
    const response = await apiClient.get('/emergency/alerts/map', {
      params: { status: 'active' },
    });
    return response.data;
  }

  async getPerformanceMetrics(): Promise<any> {
    const response = await apiClient.get('/dashboard/performance');
    return response.data;
  }

  async getSystemMonitor(): Promise<any> {
    const response = await apiClient.get('/dashboard/system-monitor');
    return response.data;
  }
}

export const dashboardService = new DashboardService();
